import {
  pathOr
} from 'ramda'

const getTargetName = pathOr('',['target', 'name'])

export default getTargetName